/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：下拉框单选组件的筛选功能
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';


/**
 * 用作下拉框搜索栏
 */
@Pipe({
  name: 'selectFilter'
})
export class SelectFilterPipe implements PipeTransform {

  transform(list: any[],filterField:string,keyword:string): any {///数据源,字段名,关键字
    if(!filterField || !keyword){
        return list;
    }
    var newlist= list.filter(x=>x[filterField].indexOf(keyword)>=0);
    return newlist
  }
}
